import { createCartStore } from "@the-drop/customer-shared/cart/create-cart-store";
import { webStorageAdapter } from "@the-drop/customer-shared/storage";

export const useCartStore = createCartStore({
  storage: webStorageAdapter(sessionStorage),
});

export type {
  CartLine,
  CartStore,
  ReconcileCartSummary,
} from "@the-drop/customer-shared/cart/create-cart-store";

export {
  cartSubtotalCents,
  formatReconcileSummary,
  lineSubtotalCents,
} from "@the-drop/customer-shared/cart/create-cart-store";
